import { connect } from 'react-redux';
import EstimateHeader from './EstimateHeader';
import { getInvalidItemsCount } from '../../selectors/getInvalidItemsCount';
import { getDiscontinuedItemsCount } from '../../selectors/getDiscontinuedItemsCount';
import { getItemsForEstimate } from '../../selectors/getItemsForEstimate';
import cookiesFactory from '../../../../base/cookies-factory';

const mapStateToProps = ({ estimateBuilder }, ownProps) => {
  const { entities, entities: { estimates } } = estimateBuilder;

  const estimate = estimates.byId[ownProps.designId];
  const hasInvalidItems = getInvalidItemsCount(entities, ownProps.designId) > 0;
  const hasDiscontinuedItems = getDiscontinuedItemsCount(entities, ownProps.designId) > 0;

  const hasCustomProduct = getItemsForEstimate(entities, ownProps.designId)
    .filter(givenItem => givenItem.itemProduct)
    .reduce((acc, givenItem) => acc || givenItem.itemProduct.productType === 'Custom', false);

  const {
    isLockedOrOrdered,
    attributes: {
      isMandi,
      isAutoReleaseDesign,
    },
  } = estimate;

  const isTHD = window.globals.siteId === 11;
  const isInternalUser = cookiesFactory.isInternalUser();
  const { repId } = cookiesFactory;
  const disableCommercialPrint = !hasInvalidItems && !isLockedOrOrdered
          && !hasDiscontinuedItems && !isMandi && !isTHD;

  return {
    name: estimate.name,
    hasInvalidItems,
    hasDiscontinuedItems,
    disableDuplicate: hasCustomProduct && !isInternalUser,
    disableCommercialPrint,
    isLockedOrOrdered,
    isMandi: isMandi === 'true',
    repId,
    isAutoReleaseDesign: isAutoReleaseDesign === 'true',
  };
};

export default connect(mapStateToProps)(EstimateHeader);
